import { GRID_DIRECTION } from "../const/grid-directions.const";

/**
 * @description Utils used for camera related actions
 */
export class CameraViewUtils {
    /**
     * @description Used to get the new camera position taking into account the temporary grid
     * @param {String} dir  - The direction the grid is expanding to
     * @param {DiagramCamera} camera - Diagram camera instance
     * @param {Object} cellMove {width, height} Object like, indicates the size of the temporary grid
     * @param {Object} prevCamera - {left,top} Object like, indicating the previous offsets before temporary grid creation
     * @returns {Object} - the new camera position taken into account the temporary grid
     */
    decideCameraPosition(dir, camera, cellMove, prevCamera) {
        if (dir !== GRID_DIRECTION.RIGHT) return this.getNewCameraPosition(camera, cellMove);
        if (dir === GRID_DIRECTION.RIGHT) return prevCamera;
    }

    /**
     * @description Returns the new camera position taking into consideration temporary grid size and current camera offsets
     * @param {DiagramCamera} camera  - DiagramCamera instance
     * @param {Object} tempSize - {width,height} obj like indicanting temporary grid size
     * @returns {Object} {left, top} indicating the new camera offsets
     */
    getNewCameraPosition(camera, tempSize) {
        return {
            left: camera.scrollbars.left + tempSize.width,
            top: camera.scrollbars.top + tempSize.height
        };
    }
}
